<template>


<v-container>

   <v-dialog v-model="dialog" overlay-opacity='10' persistent max-width="430">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">Please enter the verification code</v-card-title>
        <v-card-text>
          <v-col class='mt-3' cols="12">
          <v-text-field
          v-model='verifyCode'
            label="Enter verification code here"
            solo
            :loading='loading'
          ></v-text-field>
          <p class='red--text'>{{errorMsg}}</p>
          <v-btn v-if='showResend' :loading="resendBtnloading" outlined  @click="resendVerifyEmail()">Re-send verify code</v-btn>
        </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" :disabled='!verifyCode' text @click="verifyCodeCall">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-app-bar
      absolute
      dark
      color="green"      
    >
    

      <v-toolbar-title>Family Tree Worksheet</v-toolbar-title>

      <v-spacer></v-spacer>

     
      <v-btn :loading='finishBtnLoading' outlined @click='uploadResult'>Complete <v-icon class='pl-2' right dark>mdi-cloud-upload</v-icon></v-btn>
    </v-app-bar>
    
    <br />
    <v-banner class='mt-10 white' elevation='6' outlined two-line>
    <v-avatar
      slot="icon"
      size="80"
    >
     <v-icon size='35'>
       feedback</v-icon>
    </v-avatar>
    You are invited to help complete this family tree worksheet, please click the complete button at the top right upon finish, if you have any question, please contact <a href="mailto:admin@geneticsupportfoundation.org">admin@geneticsupportfoundation.org</a></v-banner>
  <vue-editable-grid
  class="my-grid-class mt-10 mb-5"
  ref="grid"
  id="familygrid"
  :itemHeight='50'
  :column-defs="columnDefs"
  :row-data="rows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
  <template v-slot:header>
    <h3>You, Your Parents and Your Grandparents</h3>
  </template>
  <template v-slot:header-r>

  </template>
</vue-editable-grid>
<h3 class='mt-5' >Your Children</h3>
<v-col cols="2" lg='2' sm='3' xs='5'>
 <v-text-field label="Please Enter # of Your Children" @change='addperson("childrows",numberofChild,sampledata,"Child")' v-model='numberofChild' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="childColumnDefs"
  :row-data="childrows"
   :enableFilters="false"
  row-data-key='id'
>
</vue-editable-grid>

    <h3 class='mt-5'>Your Brothers and Sisters</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field label="Please Enter # of Your Brothers and Sisters" @change='addperson("siblingrows",numberofSibling,sampledata,"Sibling")' v-model='numberofSibling' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="childColumnDefs"
  :row-data="siblingrows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>


    <h3 class='mt-5'>Your Nieces and Nephews (children of your brothers and sisters)</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field  label="Please Enter # of Your Nieces and Nephews" @change='addperson("niecesNephewsRows",numberofNiecesNephews,sampledata,"Niece or Nephew")' v-model='numberofNiecesNephews' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="fromcolumnDefs"
  :row-data="niecesNephewsRows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>

    <h3 class='mt-5'>Your Aunts and Uncles (on your mother’s side of the family)</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field  label="Please Enter # of Your Nieces and Nephews" @change='addperson("auntsUncleMomRows",numberofuncleAuntMom,sampledata,"Mothers Sibling")' v-model='numberofuncleAuntMom' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="childColumnDefs"
  :row-data="auntsUncleMomRows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>

    <h3 class='mt-5'>Your Aunts and Uncles (on your father's side of the family)</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field  label="Please Enter # of Your Nieces and Nephews" @change='addperson("auntsUncleDadRows",numberofuncleAuntDad,sampledata,"Fathers Sibling")' v-model='numberofuncleAuntDad' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="childColumnDefs"
  :row-data="auntsUncleDadRows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>

 <h3 class='mt-5'>Your Maternal Cousins (children of your mother’s brothers and sisters)</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field  label="Please Enter # of Your Nieces and Nephews" @change='addperson("cousinsDadRows",numberofCousinsDad,personFromSampledata,"Cousin")' v-model='numberofCousinsDad' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="cousinsfromcolumnDefs"
  :row-data="cousinsDadRows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>

 <h3 class='mt-5'>Your Paternal Cousins (children of your father’s brothers and sisters)</h3>
<v-col cols="4" lg='4' sm='4' xs='5'>
 <v-text-field  label="Please Enter # of Your Nieces and Nephews" @change='addperson("cousinsMomRows",numberofCousinsMom,personFromSampledata,"Cousin")' v-model='numberofCousinsMom' :hide-details="true"></v-text-field>
</v-col>
<vue-editable-grid
  class="my-grid-class mb-10"
  ref="grid"
  id="childgrid"
  :itemHeight='50'
  :column-defs="cousinsfromcolumnDefs"
  :row-data="cousinsMomRows"
    :enableFilters="false"
  row-data-key='shipmentId'
>
</vue-editable-grid>
</v-container>
</template>

<script>
import { postReq} from '../../helper/firestore'
import _ from "lodash"
export default {
    computed : {
       
    },
    mounted(){

        this.addperson("childrows",this.numberofChild,this.sampledata,"Child");
        this.addperson("siblingrows",this.numberofSibling,this.sampledata,"Sibling");
        this.addperson("niecesNephewsRows",this.numberofNiecesNephews,this.sampledata,"Niece or Nephew");
        this.addperson("auntsUncleMomRows",this.numberofuncleAuntMom,this.sampledata,"Mothers Sibling");
        this.addperson("auntsUncleDadRows",this.numberofuncleAuntDad,this.sampledata,"Fathers Sibling");
        this.addperson("cousinsDadRows",this.numberofCousinsDad,this.sampledata,"Cousin");
        this.addperson("cousinsMomRows",this.numberofCousinsMom,this.sampledata,"Cousin");

    },
    methods : {
      uploadResult(){
        this.finishBtnLoading = true ;
        const uploadData = {
          child : this.childrows,
          siblings : this.siblingrows,
          niecesNephews : this.niecesNephewsRows,
          auntsUncleMom : this.auntsUncleMomRows,
          auntsUncleDad : this.auntsUncleDadRows,
          cousinsDad : this.cousinsDadRows,
          cousinsMom : this.cousinsMomRows,
        }
        let inviteCode = this.verifyCode;


          postReq(process.env.VUE_APP_ROOT_API_URL +'/user/completeFamilytreeInvite',{
             uploadData : uploadData,
             inviteCode : inviteCode
           },result=>{
               this.finishBtnLoading = false ;
                if (result.status === 200){
                  window.alert("Thanks for submitting the family tree worksheet");
                  location.reload();
                }else{
                  window.alert(result.response.data);
                }
            })
        
      },
      resendVerifyEmail(){
          this.resendBtnloading = true;
          postReq(process.env.VUE_APP_ROOT_API_URL +'/user/resendVerifyEmail',{
             inviteCode : this.verifyCode
           },result=>{
                if (result.status === 200){
                  this.errorMsg = result.data;
                }else{
                   this.errorMsg = result.response.data;
                }
               this.resendBtnloading = false;
            })
      },
        verifyCodeCall(){

          this.errorMsg = null;
          this.loading = true;
            postReq(process.env.VUE_APP_ROOT_API_URL +'/user/verifyFamilytreeInvite',{
             inviteCode : this.verifyCode
           },result=>{
             
                if (result.status === 200){
                 
                  this.dialog = false;
                }else if(result.response.data === "invite code is expired"){
                  this.errorMsg = result.response.data;
                  this.showResend = true;
                  
                }else{
                   this.errorMsg = result.response.data;
                }
                 this.loading = false;
            })
        },
        fromcolumnDefsM(){
            return this.fromcolumnDefs;
        },
        addperson(arrayName, numberofppl, pplObj,propertyName){      
            this[arrayName] = [];
            for (let i = 0; i< numberofppl ; i++){
                const deepClonePplobj = _.cloneDeep(pplObj)
                deepClonePplobj.id = i+1;
                deepClonePplobj.name = propertyName + " " + deepClonePplobj.id
                this[arrayName].push(deepClonePplobj)
            }
            
        
        }
    },
    data(){
        return{
          finishBtnLoading : false,
          resendBtnloading : false,
          showResend : false,
          loading : false,
          errorMsg : null,
          verifyCode : null,
          dialog : true,
             collapseOnScroll: true,
            sampledata : {
                id : 0,
                name : "",
                gender : null,
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            cousinfromcolumnDefs : [],
            personFromSampledata : {
                id : 0,
                name : "",
                from : "",
                gender : null,
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            numberofCousinsDad : 2,
            numberofCousinsMom : 2,
            numberofuncleAuntMom : 2,
            numberofuncleAuntDad : 2,
            numberofNiecesNephews : 2,
            numberofSibling : 2,
            numberofChild : 2,
            cousinsDadRows : [],
            cousinsMomRows : [],
            auntsUncleMomRows : [],
             auntsUncleDadRows : [],
            niecesNephewsRows : [],
            siblingrows : [],
            childrows : [],
            rows : [{
                name : "You",
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            {
                name : "Your mother",
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            {
                name : "Your father",
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            {
                name : "Your mother’s mother(your maternal grandmother)",
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            },
            {
                name : "Your mother’s father(your maternal grandfather)",
                age : null,
                ageDeath : null,
                healthConcerns : "",
                ageDiagnosis : null,
            }
            ],
            columnDefs : [
  {field: 'name', headerName: 'Name', editable: true },
  { field: 'age', headerName: 'Current Age (living relatives)', type: 'numeric',editable: true },
  { field: 'ageDeath', headerName: 'Age at Death (deceased relatives)', type: 'numeric', editable: true },
  { field: 'healthConcerns', headerName: 'Health Concern(s)', editable: true },
  { field: 'ageDiagnosis', headerName: 'Age of diagnosis', type: 'numeric', editable: true },
    ],
    childColumnDefs : [
        {field: 'name', headerName: 'Name', editable: true },
         {field: 'gender', headerName: 'Gender Identity', editable: true },
          {field: 'age', headerName: 'Current Age (living relatives)',  type: 'numeric', editable: true },
           {field: 'ageDeath', headerName: 'Age at Death (deceased relatives)',  type: 'numeric', editable: true },
            { field: 'healthConcerns', headerName: 'Health Concern(s)', editable: true },
            { field: 'ageDiagnosis', headerName: 'Age of diagnosis', type: 'numeric', editable: true },
    ],
    cousinsfromcolumnDefs : [
        {field: 'name', headerName: 'Name', editable: true },
        {field: 'from', headerName: 'Which of your aunts/uncles is this cousin from?', editable: true },
         {field: 'gender', headerName: 'Gender Identity', editable: true },
          {field: 'age', headerName: 'Current Age (living relatives)',  type: 'numeric', editable: true },
           {field: 'ageDeath', headerName: 'Age at Death (deceased relatives)',  type: 'numeric', editable: true },
            { field: 'healthConcerns', headerName: 'Health Concern(s)', editable: true },
            { field: 'ageDiagnosis', headerName: 'Age of diagnosis', type: 'numeric', editable: true },
    ],
    fromcolumnDefs : [
        {field: 'name', headerName: 'Name', editable: true },
        {field: 'from', headerName: 'Which of your siblings is this niece/nephew from?', editable: true },
         {field: 'gender', headerName: 'Gender Identity', editable: true },
          {field: 'age', headerName: 'Current Age (living relatives)',  type: 'numeric', editable: true },
           {field: 'ageDeath', headerName: 'Age at Death (deceased relatives)',  type: 'numeric', editable: true },
            { field: 'healthConcerns', headerName: 'Health Concern(s)', editable: true },
            { field: 'ageDiagnosis', headerName: 'Age of diagnosis', type: 'numeric', editable: true },
    ],
        }
    }
}
</script>

<style>

</style>